import React, { Component } from 'react'
import { getChildren } from '../../store/reducers';
import { withRouter } from 'react-router-dom';
import {connect} from 'react-redux';

function withSiblings(WrappedComponent, parent_id){
    class Siblings extends Component {

        componentWillMount() {
            if(parent_id && !this.props.siblings){
                this.props._get_children({ page_id: parent_id })
            }
        }

        render() {
            return (
                <div>
                    <WrappedComponent {...this.props} />
                </div>
            ) 
        }
    }
    return withRouter(connect( 
        (state, ownProps) =>({
            siblings: parent_id && state.app.subpages[parent_id] ? state.app.subpages[parent_id].children : null,
            parent: parent_id && state.app.subpages[parent_id] ? state.app.subpages[parent_id] : null
        }),
        dispatch => { 
            return { 
                _get_children: (payload) => { dispatch(getChildren(payload)) } ,
            } 
        }
    )(Siblings));
}

export default withSiblings



// WEBPACK FOOTER //
// ./src/containers/withsiblings/index.js